export default __webpack_public_path__ + "static/media/arrival-banner-3.77c6f6a2.webp";